import { useUserContext } from 'webReservations/context/UserContext';
import { errorToast } from '@components/toasts/Toasts';
import { ApiError } from '@shared/api/errors';
import { reportAppError } from '@shared/reportAppError';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { getReservation } from '../reservationDetails/apiHelpers';

export const useReservationDetails = () => {
  const { isAuthenticated } = useUserContext();
  const { reservationId } = useParams();

  return useQuery({
    queryKey: ['reservations', reservationId],
    queryFn: async () => {
      try {
        return getReservation(reservationId as string);
      } catch (e) {
        if (e instanceof ApiError) {
          errorToast({ message: e.message });
        } else {
          errorToast({
            message: 'An error occurred. Please try again.',
          });
        }
        reportAppError(e);
      }
    },
    enabled: isAuthenticated && Boolean(reservationId),
  });
};
